import React from 'react'

const SentenceCard = ({
  header,
  sentence,
  color,
  cardClassName = '',
}) => {
  return (
    <div className={`p-3 bg-${color}-50 rounded-lg ${cardClassName}`}>
      <div className={`text-sm text-${color}-600 mb-1`}>{header}</div>
      <div className={`font-medium text-${color}-800`}>{sentence}</div>
    </div>
  );
}

export default SentenceCard